import { useLanguage } from "../contexts/LanguageContext";
import { en } from "../translations/en";
import { ar } from "../translations/ar";

const translations = {
  en,
  ar,
};

export const useTranslation = () => {
  const { language, isArabic } = useLanguage();

  const t = (key, params = {}) => {
    const keys = key.split(".");
    let translation = translations[language];

    // Navigate through nested keys
    for (const k of keys) {
      if (translation && typeof translation === "object") {
        translation = translation[k];
      } else {
        console.warn(
          `Translation key "${key}" not found for language "${language}"`
        );
        return key; // Return the key if translation not found
      }
    }

    if (typeof translation !== "string") {
      console.warn(
        `Translation key "${key}" is not a string for language "${language}"`
      );
      return key;
    }

    // Replace parameters in translation
    let result = translation;
    Object.keys(params).forEach((param) => {
      result = result.replace(new RegExp(`{{${param}}}`, "g"), params[param]);
    });

    return result;
  };

  return {
    t,
    language,
    isArabic,
    translations: translations[language],
  };
};
